/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DoctorAlertaControllerMarcarAlertaLeida$Params {

/**
 * UUID de la alerta a marcar como leída
 */
  uuid: string;
}

export function doctorAlertaControllerMarcarAlertaLeida(http: HttpClient, rootUrl: string, params: DoctorAlertaControllerMarcarAlertaLeida$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, doctorAlertaControllerMarcarAlertaLeida.PATH, 'put');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

doctorAlertaControllerMarcarAlertaLeida.PATH = '/api/doctor-alertas/marcar-alerta-leida/{uuid}';
